import React, { useState, Fragment, useContext, useEffect } from 'react';
import { AuthContext } from '../../../../services/user/AuthProvider';

import PublisherSearchResults from './components/BookSearchResult/publisherResults';
import IsbnSearch from './components/IsbnSearch';
import CreateBook from './components/CreateBook';

import styles from './AddBook.module.scss';
import * as Icon from 'react-feather';

import { useForm } from 'react-hook-form';
import * as Yup from 'yup';
import { useLazyQuery, useQuery } from '@apollo/react-hooks';
import { SEARCH_BOOK_TITLE, GET_RECOMMENDED_BOOKS } from '../../services/graphql';
import { useTranslation } from 'react-i18next';

const AddBook = () => {
    
    const { currentUser: user } = useContext(AuthContext);
    const { t } = useTranslation();

    const [startIndex, setStartIndex] = useState(0);
    const [showTitleResults, setShowTitleResults] = useState();
    const [searchTerm, setSearchTerm] = useState('');


    const [searchOption, setSearchOption] = useState({
        type: 'TITLE'
    });

    const { data: recommendedData, loading: recommendedLoading, error: recommendedError } = useQuery(GET_RECOMMENDED_BOOKS, {
        fetchPolicy: 'network-only',
        variables: {
            studentId: user.id,
        }
    });

    const [booksByTitle, { loading, data, error, fetchMore}] = useLazyQuery(SEARCH_BOOK_TITLE, {
        notifyOnNetworkStatusChange: true,
        fetchPolicy: 'network-only',
        variables: {
            searchApi: false
        }
    });

    useEffect(() => {
        if (data && data.booksByTitle && startIndex === 0) {
            setStartIndex(data.booksByTitle.items.length);
        }
    }, [data, setStartIndex, startIndex]);

    useEffect(() => {
        if (data && data.booksByTitle) {
            setShowTitleResults(true);
        }
    }, [data, setShowTitleResults]);

    const { register, handleSubmit, errors } = useForm({
        validationSchema: Yup.object().shape({
            search_term: Yup.string().required(t('please_enter_title'))
        })
    });

    const onSubmit = ({ search_term }) => {
        booksByTitle({variables: {title: search_term}});
        setSearchTerm(search_term);
    }

    const onFetchMore = () => {
        fetchMore({
            variables: {
              startIndex: startIndex
            },
            updateQuery: (prev, { fetchMoreResult }) => {
              if (!fetchMoreResult) return prev;
              setStartIndex(prev.booksByTitle.items.length + fetchMoreResult.booksByTitle.items.length);
              return {
                ...fetchMoreResult,
                booksByTitle: {...fetchMoreResult.booksByTitle, items: [...prev.booksByTitle.items, ...fetchMoreResult.booksByTitle.items]}
              };
            }
        })
    }
  
    return(
        <div className={styles.addBookPage}>
            <div className={styles.addBookPanel}>
                    {searchOption.type === 'TITLE' && (
                        <Fragment>
                            <h1 className={styles.addBookTitle}>Add a new book</h1>
                            <form onSubmit={handleSubmit(onSubmit)} className={styles.searchForm}>
                                <input
                                    name="search_term"
                                    placeholder="Search by Title"
                                    className={styles.searchInput}
                                    ref={register}
                                    type="text"
                                />
                                <button type="submit" className={styles.searchButton} aria-label={loading ? t('searching') : t('search')}>
                                    <Icon.Search />
                                </button>
                            </form>
                            {errors.search_term && <p className="basic-form__hint">{errors.search_term.message}</p>}
                            {error && <p>{error.message}</p>}

                            {data && data.booksByTitle && showTitleResults && (
                                <PublisherSearchResults
                                    setSearchOption={() => setSearchOption({type: 'ADD_NEW'})}
                                    loadingMore={loading}
                                    onFetchMore={onFetchMore}
                                    books={data && data.booksByTitle.items}
                                    total={data && data.booksByTitle.total}
                                    studentId={user.id} />
                            )}
                        </Fragment>
                    )}

                    {searchOption.type === 'ISBN' && <IsbnSearch close={() => {setSearchOption({type: 'TITLE'}); setShowTitleResults(false)}} setSearchOption={() => setSearchOption({type: 'ADD_NEW'})} />}
                    {searchOption.type === 'ADD_NEW' && (
                        <CreateBook
                            studentId={user.id}
                            searchTerm={searchTerm}
                            close={() => {
                                setSearchOption({type: 'TITLE'}); 
                                setShowTitleResults(false);
                                setSearchTerm('');
                            }}
                        />
                    )}
            </div>

            <div className={styles.suggestionsPanel}>
                <h1>Book suggestions</h1>
                <p>These are books we think you may enjoy based on your other reading</p>
                {recommendedLoading && <p>{t('loading')}</p>}
                {recommendedError && <p>{recommendedError.message}</p>}
                {recommendedData && recommendedData.studentRecommendedBooks && (
                    <PublisherSearchResults
                        books={recommendedData.studentRecommendedBooks}
                        recommended
                    />
                )}
            </div>

        </div>
    )
}

export default AddBook
